import { isNumber } from './isNumber';

import { FRACTION_LENGTH } from '../constants';

export function formatFloat(input, fractionLength = FRACTION_LENGTH) {
  if (!isNumber(Number(input))) return undefined;
  return parseFloat(input).toFixed(fractionLength);
}
